module.exports = __webpack_public_path__ + "static/media/6.cfa5f0ef.jpg";